(ns common.import-permissions
  (:require [common.roles :as roles]))

(defn export-access?
  [_tenant account-teams role]
  (boolean (or (roles/admin? role)
               (->> account-teams
                    (not-every? :team/deny-export-access)))))

(defn allow-export?
  [_tenant role]
  (boolean (roles/user? role)))
